import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from "@/axios/axiosConfig";
import './style/element.scss'
import * as echarts from 'echarts';

Vue.prototype.$http = http;
Vue.prototype.$echarts = echarts


http.interceptors.request.use(function (config) {
  // 向请求头加入User-Token
  config.withCredentials = true;

    const tokenUserInfo = localStorage.getItem('token')
    const appIdUserInfo = localStorage.getItem('app_id')

  if (tokenUserInfo !== null || appIdUserInfo != null){
    config.headers['access-token'] = tokenUserInfo;
    config.headers['app-id'] = appIdUserInfo;
  }



  return config;
}, function (error) {
  return Promise.reject(error);
});

// function getQueryString(name) {
//   let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
//   let r = window.location.search.substr(1).match(reg);
//   if (r != null) {
//     return decodeURIComponent(r[2]);
//   }
//   return null;
// }

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
